import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { Dialog } from '@components';
import { PAGE_PATHS } from '../../../../constants';

interface CreateActivityIncidentDialogProps {
  open: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
  operationId: string;
  incidentId: string | null;
  setIncidentId: Dispatch<SetStateAction<string | null>>;
}

const CreateActivityIncidentDialog: React.FC<CreateActivityIncidentDialogProps> = ({
  open,
  onClose,
  operationId,
  incidentId,
  setIncidentId,
}) => {
  const navigate = useNavigate();

  const handleClose = () => {
    setIncidentId(null);
    onClose(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      primaryButtonAction={handleClose}
      primaryButtonText="back to activity"
      secondaryButtonAction={() => navigate(`${PAGE_PATHS.operations}/${operationId}/incidents/${incidentId}`)}
      secondaryButtonText="go to incident"
      fullWidth={false}
      showClose={false}
    >
      <Grid container>
        <Grid size={12}>
          <Typography>This activity has been marked as a new incident.</Typography>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default CreateActivityIncidentDialog;